/**
 * Elin PDP: nhiều <details class="elin-pdp__accordion-details"> chỉ mở một tab (accordion).
 * Mục đầu mở mặc định do Liquid; khi mở tab khác, các tab còn lại được đóng.
 */
document.addEventListener(
  'toggle',
  function (e) {
    var details = e.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.classList.contains('elin-pdp__accordion-details')) return;
    if (!details.open) return;

    var root = details.closest('section[id^="ProductInfo-"]');
    if (!root) return;

    root.querySelectorAll('.elin-pdp__accordion-details').forEach(function (other) {
      if (other !== details) other.removeAttribute('open');
    });
  },
  true
);
